import { lazy } from 'react';
import { PrivateRoutes } from '@enums/privateRouteEnums';
import { PrivateRoutesTitles } from '@enums/privateRoutesTitles';
import ReviewDraw from '@components/drawRequests/ReviewDraw';
import ViewAllDraws from '@components/drawRequests/ViewAllDraws';
import DrawRequestMessage from '@components/drawRequests/DrawRequestMessage';
import WrappedRequestDraw from '@components/drawRequests/WrappedRequestDraw';
import WrappedCreateDrawMessage from '@components/drawRequests/WrappedCreateDrawMessage';

const Overview = lazy(() => import('@components/homePage/Overview'));
const ContactPage = lazy(() => import('@components/ContactPage'));
const Privacy = lazy(() => import('@components/Privacy'));
const Terms = lazy(() => import('@components/Terms'));
const Messages = lazy(() => import('@components/messages/Messages'));
const SendMessage = lazy(
  () => import('@components/messages/compose/SendMessage')
);
const ShowMessage = lazy(() => import('@components/messages/view/ShowMessage'));
const Profile = lazy(() => import('@components/profile/Profile'));
const History = lazy(() => import('@components/history/History'));
const Documents = lazy(() => import('@components/documents/Documents'));
const TrustAccount = lazy(
  () => import('@components/trustAccounts/TrustAccount')
);
const LoanDetails = lazy(
  () => import('@components/loan/loanDetails/LoanDetails')
);
const Payment = lazy(() => import('@components/payments/Payment'));
const PaymentReceipt = lazy(
  () => import('@components/payments/PaymentReceipt')
);

export const privateRoutes = [
  {
    title: PrivateRoutesTitles.OVERVIEW,
    path: PrivateRoutes.ROOT,
    component: Overview,
  },
  {
    title: PrivateRoutesTitles.CONTACT,
    path: PrivateRoutes.CONTACT,
    component: ContactPage,
  },
  {
    title: PrivateRoutesTitles.PRIVACY,
    path: PrivateRoutes.PRIVACY,
    component: Privacy,
  },
  {
    title: PrivateRoutesTitles.TERMS,
    path: PrivateRoutes.TERMS,
    component: Terms,
  },
  {
    title: PrivateRoutesTitles.MESSAGES,
    path: PrivateRoutes.MESSAGES,
    component: Messages,
  },
  {
    title: PrivateRoutesTitles.SEND_MESSAGE,
    path: PrivateRoutes.SEND_MESSAGE,
    component: SendMessage,
  },
  {
    title: PrivateRoutesTitles.SEND_MESSAGE,
    path: PrivateRoutes.SEND_MESSAGE_WITH_ACCOUNT,
    component: SendMessage,
  },
  {
    title: PrivateRoutesTitles.SHOW_MESSAGE,
    path: PrivateRoutes.SHOW_MESSAGE,
    component: ShowMessage,
  },
  {
    title: PrivateRoutesTitles.PROFILE,
    path: PrivateRoutes.PROFILE,
    component: Profile,
  },
  {
    title: PrivateRoutesTitles.LOAN_HISTORY,
    path: PrivateRoutes.HISTORY,
    component: History,
  },
  {
    title: PrivateRoutesTitles.DOCUMENTS,
    path: PrivateRoutes.DOCUMENTS,
    component: Documents,
  },
  {
    title: PrivateRoutesTitles.TRUST,
    path: PrivateRoutes.TRUST,
    component: TrustAccount,
  },
  {
    title: PrivateRoutesTitles.LOAN_DETAILS,
    path: PrivateRoutes.LOAN_DETAILS,
    component: LoanDetails,
  },
  {
    title: PrivateRoutesTitles.CONSTRUCTION_TRUST,
    path: PrivateRoutes.CONSTRUCTION_TRUST,
    component: TrustAccount,
  },
  {
    title: PrivateRoutesTitles.PAYMENT,
    path: PrivateRoutes.PAYMENT,
    component: Payment,
  },
  {
    title: PrivateRoutesTitles.REQUEST_DRAW,
    path: PrivateRoutes.REQUEST_DRAW,
    component: WrappedRequestDraw,
  },
  {
    title: PrivateRoutesTitles.REVIEW_DRAW,
    path: PrivateRoutes.REVIEW_DRAW,
    component: ReviewDraw,
  },
  {
    title: PrivateRoutesTitles.VIEW_ALL_DRAWS,
    path: PrivateRoutes.VIEW_ALL_DRAWS,
    component: ViewAllDraws,
  },
  {
    title: PrivateRoutesTitles.CREATE_DRAW_MESSAGE,
    path: PrivateRoutes.CREATE_DRAW_MESSAGE,
    component: WrappedCreateDrawMessage,
  },
  {
    title: PrivateRoutesTitles.DRAW_REQUEST_MESSAGE,
    path: PrivateRoutes.DRAW_REQUEST_MESSAGE,
    component: DrawRequestMessage,
  },
  {
    title: PrivateRoutesTitles.PAYMENT_RECEIPT,
    path: PrivateRoutes.PAYMENT_RECEIPT,
    component: PaymentReceipt,
  },
];
